import React from 'react'
import SamgovSearchView from './SamgovSearchView'

const SamgovSearch = ({ isQuickSearch = true, applicantId = '' }) => {
    return (
        <div className={`${!isQuickSearch ? 'm-3' : ''}`}>
            <SamgovSearchView isQuickSearch={isQuickSearch} applicantId={applicantId} />
        </div>
    )
}

export default SamgovSearch
